export const statusBoardQueryKeys = {
  root: ['status-board'] as const,
  board: (workspaceId: string, rangeDays: number) =>
    [...statusBoardQueryKeys.root, workspaceId, rangeDays] as const,
};
